/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetailerCreateRequest
 */
export interface RetailerCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof RetailerCreateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerCreateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerCreateRequest
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerCreateRequest
     */
    externalCode?: string;
}

/**
 * Check if a given object implements the RetailerCreateRequest interface.
 */
// @ts-ignore
export function instanceOfRetailerCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "currencyCode" in value;

    return isInstance;
}

// @ts-ignore
export function RetailerCreateRequestFromJSON(json: any): RetailerCreateRequest {
    return RetailerCreateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function RetailerCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerCreateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organization_id'],
        'name': json['name'],
        'email': json['email'],
        'currencyCode': json['currency_code'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
    };
}

// @ts-ignore
export function RetailerCreateRequestToJSON(value?: RetailerCreateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organizationId,
        'name': value.name,
        'email': value.email,
        'currency_code': value.currencyCode,
        'external_code': value.externalCode,
    };
}

